import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Lock, Clock } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import EmptyState from "@/components/EmptyState";
import Attachments from "@/components/Attachments";

export default function WritingDetail() {
  const { slug } = useParams();
  const { t } = useLang();
  const navigate = useNavigate();
  const [item, setItem] = useState(undefined);

  useEffect(() => {
    api.get(`/content/${slug}`).then((r) => setItem(r.data)).catch(() => setItem(null));
  }, [slug]);

  if (item === undefined) {
    return <div className="max-w-3xl mx-auto px-4 sm:px-8 py-24"><div className="h-8 w-2/3 bg-[#FFFFFF] animate-pulse rounded mb-6" /><div className="space-y-3">{[...Array(6)].map((_, i) => <div key={i} className="h-4 bg-[#FFFFFF] animate-pulse rounded" />)}</div></div>;
  }
  if (item === null) {
    return <div className="pt-10"><EmptyState title={t("not_found")} desc={t("empty_desc")} /></div>;
  }

  return (
    <article data-testid="writing-detail" className="max-w-3xl mx-auto px-4 sm:px-8 pt-14 sm:pt-20 pb-24">
      <button onClick={() => navigate("/writing")} data-testid="writing-back"
        className="inline-flex items-center gap-2 text-sm text-[#9C8F94] hover:text-[#C6899E] transition-colors mb-10">
        <ArrowLeft className="w-4 h-4" /> {t("nav_writing")}
      </button>

      {item.cover_path && (
        <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-10 border border-[rgba(61,50,56,0.08)]">
          <img src={mediaUrl(item.cover_path)} alt={item.title} className="w-full h-full object-cover" />
        </div>
      )}

      <div className="flex items-center gap-3 text-xs text-[#9C8F94] mb-5 uppercase tracking-[0.15em]">
        {item.reading_time ? <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {item.reading_time} {t("reading_time")}</span> : null}
        {item.tags?.map((tg) => <span key={tg}>#{tg}</span>)}
      </div>

      <h1 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight leading-[1.05] mb-8">{item.title}</h1>

      {item.locked ? (
        <div className="rounded-2xl border border-[rgba(198,137,158,0.3)] bg-[#FFFFFF] p-10 text-center">
          <Lock className="w-8 h-8 text-[#C6899E] mx-auto mb-4" />
          <h3 className="font-serif text-2xl mb-2">{t("locked")}</h3>
          <p className="text-[#8C7E83] mb-6">{item.excerpt}</p>
          <Link to="/premium" data-testid="detail-unlock"
            className="inline-flex bg-[#C6899E] text-[#4A2233] rounded-full px-7 py-3 text-sm uppercase tracking-[0.15em] hover:bg-[#B4718C] transition-colors">
            {t("unlock")}
          </Link>
        </div>
      ) : (
        <div className="prose-unfiltered">
          {(item.body || item.excerpt || "").split("\n\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
          <Attachments files={item.attachments} label="Allegati" />
        </div>
      )}
    </article>
  );
}
